import { KulionerOrder } from "@/domain/entities/Kulioner";
import jsPDF from "jspdf";

export interface Product {
  name: string;
  quantity: string;
}

export interface DocumentState {
  x: number;
  y: number;
  startYTable: number;
  startXSignature: number;
}

export class KulionerReceiptSectionProps {
  doc!: PDFDocument;
  x = 0;
  y = 0;
  pageWidth = 0;
  pageHeight = 0;
  importLogo: any;
  data = new KulionerOrder();

  constructor(fields?: Partial<KulionerReceiptSectionProps>) {
    Object.assign(this, fields);
  }
}

export type PDFDocument = jsPDF & {
  lastAutoTable: {
    finalY: number;
  };
};
